import React, { Component } from 'react';

import './styles.css';

class Button extends Component {
  render() {
    const {
      onClick,
      text,
      href,
      type,
      block,
      className,
      disabled,
      children
    } = this.props;

    if (href) {
      return (
        <a
          className={`
            Button
            ${block ? ' Button--block ' : ''}
            ${className}
          `}
          href={href}
        >
          {text}
        </a>
      )
    }

    return (
      <button
        type={type}
        className={`
          Button
          ${block ? ' Button--block ' : ''}
          ${className}
        `}
        onClick={onClick}
        disabled={disabled}
      >
        {text ? text : children}
      </button>
    );
  }
}

export default Button;
